import React from 'react';
import BenchLogo from './BenchLogo';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const HeaderLayout = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
  padding-bottom: 16px;
`;

const Header = ({ headerText, subHeaderText }) => (
  <HeaderLayout>
    <BenchLogo alt="Bench Logo" src="/assets/images/bench-logo.svg" />
    <h1>{headerText}</h1>
    {subHeaderText && <p>{subHeaderText}</p>}
  </HeaderLayout>
);

export default Header;

Header.propTypes = {
  headerText: PropTypes.string.isRequired,
  subHeaderText: PropTypes.string,
};

Header.defaultProps = {
  subHeaderText: undefined,
};
